export const SITE_HEADER = 'Lesson Completion Snapshot'
export const SITE_HEADER_OVERVIEW_BASE = 'Lesson Completion Overview'
